import { debounceTime, fromEvent } from 'rxjs';
import { emailAddress as emailAddressPattern } from 'constants/regexExpressions';

/**
 * Enables or disables the submit button based on form validation state.
 * @param {boolean} enabled - Whether the button should be disabled (true) or enabled (false)
 */
function disableButton(enabled) {
  const submitButton = document.querySelector("[data-unsubscribe-form-submit]");
  submitButton.disabled = enabled;
}

/**
 * Removes error styling from an input field wrapper.
 * @param {HTMLInputElement} input - The input element to remove error styling from
 */
function hideError(input) {
  const wrapper = input.closest('[data-unsubscribe-input-wrapper]');
  wrapper.classList.remove('nhs-c-input__wrapper--error');
}

/**
 * Adds error styling to an input field wrapper.
 * @param {HTMLInputElement} input - The input element to add error styling to
 */
function showError(input) {
  const wrapper = input.closest('[data-unsubscribe-input-wrapper]');
  wrapper.classList.add('nhs-c-input__wrapper--error');
}

/**
 * Validates email input field against email address pattern.
 * Shows/hides error states and enables/disables submit button accordingly.
 * @param {Event} event - The input event (blur or keyup)
 */
function emailValidation(event) {
  const emailInput = event.target;
  hideError(emailInput);

  // Validate email
  if (!emailInput.value || !emailInput.value.match(emailAddressPattern)) {
    showError(emailInput);
    disableButton(true);
    return;
  }

  disableButton(false);
}

/**
 * Initializes email validation for the unsubscribe form.
 * Sets up blur and debounced keyup event listeners for email validation.
 */
export default function init() {
  const emailInput = document.querySelector("[data-unsubscribe-form-email]");
  if (emailInput) {
    // Validate on blur, when the user is logged in, we don't show the email input
    fromEvent(emailInput, 'blur').subscribe(emailValidation);
    fromEvent(emailInput, 'keyup').pipe(debounceTime(800)).subscribe(emailValidation);
  }
}
